import { Container } from "@chakra-ui/react";
import type {
    ComponentParams,
    ComponentRendering,
    Field,
    ImageField,
    LinkField,
} from "@sitecore-jss/sitecore-jss-nextjs";
import { type PartnerResult } from "./PartnersFilter";
import PartnerLayout from "commons/ui/Partner/PartnerLayout";

interface Fields {
    Tags: Field<string>;
    Logo: ImageField;
    PartnerName: Field<string>;
    Video: Field<string>;
    ThumbnailImage: ImageField;
    ThumbnailUrl: Field<string>;
    TeaserHeadline: Field<string>;
    TeaserText: Field<string>;
    Headline: Field<string>;
    SubHeadline: Field<string>;
    Text: Field<string>;
    WebsiteLink: LinkField;
    LinkedInLink: LinkField;
    DownloadLink: LinkField;
    InternalPageLink: LinkField;
}
type PartnerProps = {
    rendering?: ComponentRendering & { params: ComponentParams };
    fields: Fields;
};

const Partner = (props: PartnerProps) => {
    const partner: PartnerResult = {
        partnerName: { jsonValue: props.fields.PartnerName },
        headline: { jsonValue: props.fields.Headline },
        subHeadline: { jsonValue: props.fields.SubHeadline },
        teaserHeadline: { jsonValue: props.fields.TeaserHeadline },
        teaserText: { jsonValue: props.fields.TeaserText },
        text: { jsonValue: props.fields.Text },
        video: { jsonValue: props.fields.Video },
        thumbnailImage: { jsonValue: props.fields.ThumbnailImage },
        thumbnailUrl: { jsonValue: props.fields.ThumbnailUrl },
        logo: { jsonValue: props.fields.Logo },
        websiteLink: { jsonValue: props.fields.WebsiteLink },
        downloadLink: { jsonValue: props.fields.DownloadLink },
        internalPageLink: { jsonValue: props.fields.InternalPageLink },
        linkedInLink: { jsonValue: props.fields.LinkedInLink },
        id: "",
    };

    return (
        <Container>
            <PartnerLayout {...partner} />
        </Container>
    );
};

export default Partner;
